export const EXPIRATION_STAGED_LENGTH = 4;
export const CVV_STAGED_LENGTH = 3;
export const CVV_MAX_LENGTH = 4;
export const CARD_STAGED_LENGTH = 16;

export const PHONE_STAGED_LENGTH = 10;

export const ROUTING_NUMBER_STAGED_LENGTH = 9;

export const ACCOUNT_NUMBER_MIN_LENGTH = 4;
export const ACCOUNT_NUMBER_MAX_LENGTH = 17;

export const NAME_MIN_LENGTH = 5;
export const NAME_MAX_LENGTH = 100;
export const COMPANY_MAX_LENGTH = 100;

export const ZIP_CODE_MIN_LENGTH = 5;
export const ZIP_CODE_MAX_LENGTH = 10;
export const ADDRESS_LINE_MAX_LENGTH = 100;
export const CITY_MAX_LENGTH = 50;
